import { Loader } from '@/shared/components';
import ExchangeQuickSelectButton from './ExchangeQuickSelectButton';
import {
  type ExchangeAsset as ExchangeAssetType,
  type ExchangeInputSectionType,
  useExchangeQuickSelect,
} from '../model';

type Props = {
  onSelect: (asset: string) => void;
  type: ExchangeInputSectionType;
  assetsOptions: Array<ExchangeAssetType>;
};

const ExchangeQuickSelectSection = ({
  onSelect,
  type,
  assetsOptions,
}: Props) => {
  const { exchangeQuickSelectData, isExchangeQuickSelectLoading } =
    useExchangeQuickSelect(type, assetsOptions);

  return isExchangeQuickSelectLoading ? (
    <Loader />
  ) : (
    <div className="flex flex-wrap items-center justify-end gap-[1.6rem]">
      {exchangeQuickSelectData.map(({ asset }, index) => (
        <ExchangeQuickSelectButton
          key={`${asset.code}-${index}`}
          asset={asset}
          onClick={() => onSelect(asset.code)}
        />
      ))}
    </div>
  );
};

export { ExchangeQuickSelectSection };
